<!--
    EiToolingSummaryHeaderComponent Template

    Sticky header: record id, status badges, review flags,
    parent import context, re-lookup counter.
-->

<div class="flex flex-wrap align-items-center gap-2">
    <span class="text-lg font-bold">
        Datensatz #{{ record?.id ?? '–' }}
    </span>

    <p-tag [value]="recordStatusLabel" [severity]="recordStatusSeverity"></p-tag>

    @if (parentImport?.phase != null) {
        <p-tag [value]="phaseLabel" [severity]="phaseSeverity"></p-tag>
    }

    @if (record?.requiresManualReview) {
        <p-tag
                severity="warn"
                value="Review erforderlich"
                icon="fa-solid fa-user-check">
        </p-tag>
    }

    @if ((record?.conflictCount ?? 0) > 0) {
        <p-tag
                severity="info"
                [value]="record.conflictCount + ' Konflikte'">
        </p-tag>
    }

    <span class="text-400">|</span>

    <span class="text-sm text-600">
        Import #{{ record?.eiImportDtoId ?? parentImport?.id ?? '–' }}
    </span>

    @if (parentImport?.importTypeDtoName) {
        <span class="text-xs text-500">
            &middot; {{ parentImport.importTypeDtoName }}
        </span>
    }

    @if ((record?.reResolveCount ?? 0) > 0) {
        <span class="text-xs text-500 ml-2">
            <i class="fa-regular fa-rotate-right mr-1"></i>
            Re-Lookup: {{ record.reResolveCount }}x
        </span>
    }
</div>
